<template>
  <div class="customer-profile-widget">
    <div class="__head">
      <div class="personal_data">
        <div class="person-card">
          <img
            v-if="customer.profile_picture"
            :src="$fullUrl('images/profiles/' + customer.profile_picture)"
          />
          <img v-else src="@/assets/avatar.png" alt />
          <div class="info-text">
            <h2>{{ customer.name | validate }}</h2>
            <span>{{ customer.address | validate }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="__body">
      <div class="customer-profile-wrapper">
        <!-- customer-profile display -->
        <div class="customer-profile-container" v-animate-css="'fadeIn'">
          <div class="customer-profile-header">
            <div class="customer-profile-brand">
              <p v-html="customer.description"></p>
              <div class="customer-profile-option">
                <a class="go-to-read-btn" @click.prevent="message()">Message</a>
                <button
                  class="share-btn-transparent"
                  @click="show_share = true"
                >
                  Share
                </button>
              </div>
            </div>
            <div class="customer-profile-options"></div>
          </div>
          <div class="customer-profile-body">
            <ul class="assignments-items" v-if="assignment.length">
              <li class="assignments-starter">
                <div class="assignments-item-header">
                  <label>Assignments</label>
                </div>
              </li>

              <li
                class="assignments-item"
                v-for="(item, index) in assignment"
                :key="index + 'assignment'"
              >
                <panel-expand :expand="false">
                  <template v-slot:header>
                    <div class="assignments-item-header">
                      <div class="assignments-item-brand">
                        <img
                          v-if="item.user.customer_profile.logo"
                          :src="
                            $fullUrl(
                              'images/profiles/' +
                                item.user.customer_profile.logo
                            )
                          "
                          alt
                        />
                        <img v-else src="@/assets/icons/logo_avatar.svg" alt />
                      </div>
                      <div class="content">
                        <div class="title">
                          <label>{{ item.title | validate }}</label>
                        </div>
                        <span class="date">{{
                          item.due_date_from | formatDate | validate
                        }}</span>
                        <span>{{ item.duration | validate }}</span>
                        <span>{{ item.address | validate }}</span>
                      </div>
                    </div>
                  </template>
                </panel-expand>
              </li>
            </ul>
            <div class="empty-widget" v-else>
              <p>
                {{ customer.name | validate }} has not added any assignment yet.
              </p>
            </div>
          </div>
        </div>
        <!-- End -->
      </div>
    </div>

    <div class="floater">
      <chat :stranger="newChat" v-if="access_token"></chat>
    </div>
    <share-helper
      v-if="show_share"
      @onClose="show_share = false"
      :title="customer.name"
      description
    />
  </div>
</template>

<script>
import panelExpand from "@/components/Partials/panelExpand";
import { mapGetters } from "vuex";
import Chat from "@/components/Chat/Chat";
export default {
  name: "profile",
  components: {
    panelExpand,
    Chat,
  },
  props: {},
  data: () => {
    return {
      customer: {},
      assignment: [],
      newChat: {},
      access_token: null,
      show_share: false,
    };
  },
  mounted() {
    let vm = this;
    vm.access_token = sessionStorage.authToken;
    if (vm.$route.params.name) {
      let tmp = vm.$route.params.name.split("-");
      let id = window.atob(tmp[tmp.length - 1]);
      vm.getCustomer(id);
      vm.getAssigment(id);
    }
  },
  computed: {},
  methods: {
    message() {
      let vm = this;
      if (vm.access_token) {
        vm.newChat = vm.customer;
      } else {
        vm.$notify({
          group: "status",
          title: "It's important",
          text: "You have to Login or Create account",
          type: "warn",
          duration: 4000,
        });
        vm.$router.push({ name: "login" });
      }
    },
    getCustomer(id) {
      let vm = this;
      vm.$store.dispatch("LOADER_START");
      vm.$store
        .dispatch("GET_CUSTOMER_BY_ID", { id: id })
        .then((responce) => {
          vm.$store.dispatch("LOADER_CLOSE");
          vm.customer = responce.data;
        })
        .catch((error) => {
          console.error("GET_CUSTOMER_BY_ID:", { error });
        });
    },
    getAssigment(id) {
      let vm = this;
      vm.$store.dispatch("LOADER_START");
      vm.$store
        .dispatch("GET_ASSIGNMENT_BY_CUSTOMER_ID", { id: id })
        .then((responce) => {
          vm.$store.dispatch("LOADER_CLOSE");
          vm.assignment = responce.data;
        })
        .catch((error) => {
          console.error("GET_ASSIGNMENT_BY_CUSTOMER_ID", { error });
        });
    },
  },
  watch: {
    "$route.params.name"(name) {
      let vm = this;
      let tmp = vm.$route.params.name.split("-");
      let id = window.atob(tmp[tmp.length - 1]);
      vm.getCustomer(id);
      vm.getAssigment(id);
    },
  },
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";
.customer-profile-widget {
  background: #efefef;
  min-height: 500px;
  width: 100%;
  padding-top: 52px;
  padding-bottom: 50px;
  display: flex;
  align-items: center;
  flex-direction: column;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  .__head {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 70px;
    width: 100%;

    .personal_data {
      width: 100%;
      height: 100%;
      background-size: cover;
      display: flex;
      justify-content: center;
      align-items: center;
      background-image: url($assets + "/images/backgrounds/wallpaper.svg");
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      .person-card {
        display: flex;
        align-items: center;
        flex-direction: row;

        img {
          width: 40px;
          height: 40px;
          border-radius: 100%;
          object-fit: contain;
          margin-right: 15px;
          transition: 400ms ease-in;
        }
        .info-text {
          display: flex;
          align-items: flex-start;
          flex-direction: column;
          h2 {
            font-size: 16px;
            font-weight: bolder;
            margin-bottom: 0px;
            color: #fff;
            transition: 400ms ease-in;
          }
          span {
            font-size: 13px;
            color: #fff;
            transition: 400ms ease-in;
          }
        }
      }
    }
  }
  .__onscoll_header {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 120px;
    width: 100%;
    transition: 200ms ease-in;
  }
  .__body {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    height: calc(100% - 70px);
    overflow-x: hidden;
    overflow-y: auto;
    .customer-profile-wrapper {
      padding-top: 10px;
      width: 800px;
      @media (min-width: 300px) and (max-width: 630px) {
        width: 100%;
      }
      .customer-profile-container {
        padding: 1px;
        .customer-profile-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 20px;
          border-radius: 5px;
          background: #ffffff;
          margin-bottom: 10px;

          .customer-profile-brand {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            img {
              width: 60px;
              height: 60px;
              object-fit: contain;
              margin-bottom: 10px;
              border-radius: 50%;
            }
            span {
              font-size: 14px;
              margin-bottom: 10px;
            }
            p {
              text-align: center;
              font-size: 14px;
              line-height: 20px;

              margin: 10px 50px 10px 50px;
            }
            .customer-profile-option {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 100%;
              .go-to-read-btn {
                background: #1885ad;
                border-radius: 5px;
                padding: 10px 18px;
                font-size: 14px;
                margin-top: 13px;
                color: #fff;
                cursor: pointer;
                outline: none;
                width: 180px;
                margin-right: 20px;

                text-decoration: none;
                text-align: center;
              }
              .share-btn-transparent {
                background: #ffffff 0% 0% no-repeat padding-box;
                border: 1px solid #707070;
                border-radius: 5px;
                padding: 10px 18px;
                font-size: 14px;
                margin-top: 13px;
                color: #646262;
                cursor: pointer;
                outline: none;
                width: 180px;

                border: 1px solid #ccc;
              }
            }
          }
          .customer-profile-options {
            .btn-edit-info {
              box-shadow: 0px 1px 3px #00000029;
              border: 1px solid #36adae;
              border-radius: 5px;
              color: #1885ad;
              padding: 10px 50px;
            }
          }
        }
        .customer-profile-body {
          padding: 20px;
          border-radius: 5px;
          background: #ffffff;
          ul {
            margin-left: -38px;
            list-style: none;
            .assignments-starter {
              margin-bottom: 6px;
              .assignments-item-header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0px 0px 0px 54px;
                label {
                  color: #000000;

                  font-size: 16px;
                }
                .btn-add-assignment {
                  color: #1ba5a4;
                  border: none;
                  padding: 10px 10px;
                  font-size: 14px;
                  outline: none;
                  cursor: pointer;

                  font-style: italic;
                  background: transparent;
                }
              }
              p {
                color: #131313;
              }
            }
            .assignments-item {
              background: #f5f5f5 0% 0% no-repeat padding-box;
              border-radius: 5px;
              margin-bottom: 10px;
              .assignments-item-header {
                padding: 10px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 10px 10px 10px 54px;
                .assignments-item-brand {
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                  img {
                    width: 60px;
                    height: 60px;
                    object-fit: cover;
                    margin-right: 15px;
                  }
                }
                .content {
                  display: flex;
                  flex-direction: column;
                  width: 100%;
                  .title {
                    display: flex;
                    justify-content: space-between;
                    width: 100%;

                    .date {
                      color: #808080;

                      font-size: 13px;
                    }
                  }
                  label {
                    display: block;
                    font-size: 14px;

                    margin-bottom: 7px;
                    font-weight: 800;
                  }
                  span {
                    color: #808080;

                    font-size: 13px;
                    margin-bottom: 6px;
                  }
                }
                .toogle-panel-btn {
                  padding: 1px 40px;
                  font-size: 30px;
                  background: transparent;
                  border: none;
                  outline: none;
                  cursor: pointer;
                  color: #ccc;
                }
              }
              .assignments-item-body {
                padding: 10px;
                h4 {
                }
                img {
                  width: 100%;
                }
                p {
                  font-size: 14px;
                }
                label {
                  color: #808080;
                  font-size: 15px;
                  display: block;
                  margin-bottom: 8px;
                }
                .skills-widget {
                  display: flex;
                  flex-wrap: wrap;
                  .skill-item {
                    background: #707070 0% 0% no-repeat padding-box;
                    border-radius: 25px;
                    color: #ffffff;
                    font-size: 13px;

                    padding: 5px 22px;
                    margin-right: 10px;
                    margin-bottom: 10px;
                  }
                }
                .assignments-info {
                  display: flex;
                  justify-content: space-between;
                  margin-top: 20px;
                  .col-one,
                  .col-two {
                    width: 50%;
                    label {
                      color: #808080;
                      margin-bottom: 3px;
                      margin-top: 20px;
                    }
                    p {
                      color: #000;
                      margin: 0px;
                    }
                  }
                }
              }
            }
          }
          .empty-widget {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 300px;
          }
        }
      }
      .information-container {
        background: #f5f5f5 0% 0% no-repeat padding-box;
        border-radius: 5px;
        padding: 40px;
        .information-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 20px;
          .information-brand {
            display: flex;
            align-items: center;
            justify-content: space-between;
            img {
              width: 100px;
              margin-right: 20px;
            }
            span {
            }
          }
          .information-options {
            .btn-edit-info {
              box-shadow: 0px 1px 3px #00000029;
              border: 1px solid #36adae;
              border-radius: 5px;
              color: #1885ad;
              padding: 10px 50px;
            }
          }
        }
        .information-body {
          padding: 20px;
          ul {
            margin-left: -38px;
            list-style: none;
            .information-item {
              margin-bottom: 30px;
              label {
                color: #808080;
              }
              p {
                color: #131313;
              }
            }
          }
        }
      }
    }
  }
  .__onscoll_body {
    height: calc(100% - 120px);
    transition: 1s ease-in;
  }
}

.input-flex {
  display: flex;
}

@media only screen and (max-width: 600px) {
  .customer-profile-wrapper {
    width: 100%;
    .customer-profile-container {
      padding: 1px;
      .customer-profile-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px;
        border-radius: 0px;
        background: #ffffff;
        box-shadow: 0px 0px 0px #00000029;
        margin-bottom: 2px;

        .customer-profile-brand {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          img {
            width: 60px;
            height: 60px;
            object-fit: cover;
            margin-bottom: 10px;
          }
          span {
            font-size: 14px;
            margin-bottom: 10px;
          }
          p {
            text-align: center;
            font-size: 14px;
            line-height: 20px;

            margin: 10px 11px 10px 10px;
          }
          .customer-profile-option {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            .go-to-read-btn {
              background: #1885ad 0% 0% no-repeat padding-box;
              box-shadow: 0px 1px 3px #00000029;
              border: 0.30000001192092896px solid #707070;
              border-radius: 5px;
              padding: 10px 4px;
              font-size: 14px;
              margin-top: 13px;
              color: #fff;
              cursor: pointer;
              outline: none;
              width: 158px;
              margin-right: 20px;

              text-decoration: none;
              text-align: center;
            }
            .edit-btn {
              background: #ffffff 0% 0% no-repeat padding-box;
              box-shadow: 0px 1px 3px #00000029;
              border: 0.30000001192092896px solid #707070;
              border-radius: 5px;
              padding: 10px 18px;
              font-size: 14px;
              margin-top: 13px;
              color: #646262;
              cursor: pointer;
              outline: none;
              width: 202px;

              border: 1px solid #ccc;
            }
          }
        }
        .customer-profile-options {
          .btn-edit-info {
            box-shadow: 0px 1px 3px #00000029;
            border: 1px solid #36adae;
            border-radius: 5px;
            color: #1885ad;
            padding: 10px 50px;
          }
        }
      }
      .customer-profile-body {
        padding: 20px;
        border-radius: 0px;
        background: #ffffff;
        box-shadow: 0px 0px 0px #00000029;
        ul {
          margin-left: -38px;
          list-style: none;
          .assignments-starter {
            margin-bottom: 6px;
            .assignments-item-header {
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding: 0px 0px 0px 4px;
              label {
                color: #000000;

                font-size: 16px;
              }
              .btn-add-assignment {
                color: #1ba5a4;
                border: none;
                padding: 10px 10px;
                font-size: 14px;
                outline: none;
                cursor: pointer;

                font-style: italic;
                background: transparent;
              }
            }
            p {
              color: #131313;
            }
          }
          .assignments-item {
            background: #f5f5f5 0% 0% no-repeat padding-box;
            border-radius: 5px;
            margin-bottom: 10px;
            .assignments-item-header {
              padding: 10px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 10px 10px 10px 14px;
              .assignments-item-brand {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                img {
                  width: 60px;
                  height: 60px;
                  object-fit: cover;
                  margin-right: 15px;
                }
              }
              .info {
                display: flex;
                flex-direction: column;
                width: 100%;
                .title {
                  display: flex;
                  justify-content: space-between;
                  width: 100%;

                  .date {
                    color: #808080;

                    font-size: 13px;
                  }
                }
                label {
                  display: block;
                  font-size: 14px;

                  margin-bottom: 7px;
                  font-weight: 800;
                }
                span {
                  color: #808080;

                  font-size: 13px;
                  margin-bottom: 6px;
                }
              }
              .toogle-panel-btn {
                padding: 1px 40px;
                font-size: 30px;
                background: transparent;
                border: none;
                outline: none;
                cursor: pointer;
                color: #ccc;
              }
            }
            .assignments-item-body {
              padding: 10px;
              h4 {
              }
              img {
                width: 100%;
              }
              p {
                font-size: 14px;
              }
              label {
                color: #808080;
                font-size: 15px;
                display: block;
                margin-bottom: 8px;
              }
              .skills-widget {
                display: flex;
                flex-wrap: wrap;
                .skill-item {
                  background: #707070 0% 0% no-repeat padding-box;
                  border-radius: 25px;
                  color: #ffffff;
                  font-size: 13px;

                  padding: 5px 22px;
                  margin-right: 10px;
                  margin-bottom: 10px;
                }
              }
              .assignments-info {
                display: flex;
                justify-content: space-between;
                margin-top: 20px;
                .col-one,
                .col-two {
                  width: 50%;
                  label {
                    color: #808080;
                    margin-bottom: 3px;
                    margin-top: 20px;
                  }
                  p {
                    color: #000;
                    margin: 0px;
                  }
                }
              }
            }
          }
        }
      }
    }
    .information-container {
      background: #f5f5f5 0% 0% no-repeat padding-box;
      border-radius: 5px;
      padding: 40px;
      .information-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px;
        .information-brand {
          display: flex;
          align-items: center;
          justify-content: space-between;
          img {
            width: 100px;
            margin-right: 20px;
          }
          span {
          }
        }
        .information-options {
          .btn-edit-info {
            box-shadow: 0px 1px 3px #00000029;
            border: 1px solid #36adae;
            border-radius: 5px;
            color: #1885ad;
            padding: 10px 50px;
          }
        }
      }
      .information-body {
        padding: 20px;
        ul {
          margin-left: -38px;
          list-style: none;
          .information-item {
            margin-bottom: 30px;
            label {
              color: #808080;
            }
            p {
              color: #131313;
            }
          }
        }
      }
    }
  }
}
.floater {
  position: fixed;
  bottom: 0px;
  z-index: 99999;
  right: 10px;
}
</style>